import _ from 'lodash';
import axios from 'axios';
import qs from 'qs';
import { EventBus } from '@/event-bus';
import { iwalyNotify } from '@/notify';
import Exceptions from '@/api/exceptions.json';

export const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
});

const HTTP_UNAUTHORIZED = 401;
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;
      if (status === HTTP_UNAUTHORIZED) {
        EventBus.$emit('unauthorized');
      } else {
        const e = _.get(error.response, 'data.error');
        const message = _.get(Exceptions, e) || 'Что-то пошло не так. Произошла ошибка';
        iwalyNotify.error({
          text: message,
        });
      }
    }
    return Promise.reject(error);
  },
);

export default {
  post: async (path, payload, options = {}) => axiosInstance.post(path, payload, options),
  put: async (path, payload, options = {}) => axiosInstance.put(path, payload, options),
  get: async (path, payload) => axiosInstance.get(path, {
    ...payload,
    paramsSerializer: (params) => qs.stringify(params),
  }),
  patch: async (path, payload) => axiosInstance.patch(path, payload),
  delete: async (path) => axiosInstance.delete(path),
};
